export enum RoutesServices {
    SERVICES = 'services',
}